export default __webpack_public_path__ + "static/media/V375_RoHS.824f1265.pdf";